/* @flow */
import * as React from 'react';

const PickATime = props => (
  <svg
    width={90}
    height={91}
    viewBox="0 0 90 91"
    fillRule="evenodd"
    stroke="#1C1F34"
    strokeWidth={3}
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      d="M68.447,72.014 C68.162,66.358 67.914,60.702 67.858,55.038 C67.027,54.926 66.186,54.849 65.325,54.849 C55.44,54.849 47.347,62.439 46.435,72.089 C53.772,72.079 61.11,72.047 68.447,72.014"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      d="M69.538,25 L2.462,25 C1.654,25 1,24.328 1,23.5 C1,22.672 1.654,22 2.462,22 L69.538,22 C70.346,22 71,22.672 71,23.5 C71,24.328 70.346,25 69.538,25"
    />
    <polygon fill="#FFFFFF" points="70.5 73.5 34.378 73.5 1.5 73.5 1.5 7.5 70.5 7.5" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      points="1.5 21.38 70.325 21.38 70.325 7.586 1.5 7.586"
    />
    <path d="M1.5,21.5 L70.5,21.5" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M56.448,1.5 L56.358,1.5 C54.926,1.5 53.765,2.661 53.765,4.093 L53.765,12.845 C53.765,14.277 54.926,15.438 56.358,15.438 L56.448,15.438 C57.88,15.438 59.041,14.277 59.041,12.845 L59.041,4.093 C59.041,2.661 57.88,1.5 56.448,1.5"
    />
    <path d="M56.551,1.5 L56.449,1.5 C54.82,1.5 53.5,2.666 53.5,4.105 L53.5,12.895 C53.5,14.334 54.82,15.5 56.449,15.5 L56.551,15.5 C58.18,15.5 59.5,14.334 59.5,12.895 L59.5,4.105 C59.5,2.666 58.18,1.5 56.551,1.5 Z" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M35.958,1.5 L35.868,1.5 C34.436,1.5 33.275,2.661 33.275,4.093 L33.275,12.845 C33.275,14.277 34.436,15.438 35.868,15.438 L35.958,15.438 C37.39,15.438 38.551,14.277 38.551,12.845 L38.551,4.093 C38.551,2.661 37.39,1.5 35.958,1.5"
    />
    <path d="M36.551,1.5 L36.449,1.5 C34.82,1.5 33.5,2.666 33.5,4.105 L33.5,12.895 C33.5,14.334 34.82,15.5 36.449,15.5 L36.551,15.5 C38.18,15.5 39.5,14.334 39.5,12.895 L39.5,4.105 C39.5,2.666 38.18,1.5 36.551,1.5 Z" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M15.467,1.5 L15.377,1.5 C13.945,1.5 12.784,2.661 12.784,4.093 L12.784,12.845 C12.784,14.277 13.945,15.438 15.377,15.438 L15.467,15.438 C16.899,15.438 18.06,14.277 18.06,12.845 L18.06,4.093 C18.06,2.661 16.899,1.5 15.467,1.5"
    />
    <path d="M15.551,1.5 L15.449,1.5 C13.82,1.5 12.5,2.666 12.5,4.105 L12.5,12.895 C12.5,14.334 13.82,15.5 15.449,15.5 L15.551,15.5 C17.18,15.5 18.5,14.334 18.5,12.895 L18.5,4.105 C18.5,2.666 17.18,1.5 15.551,1.5 Z" />
    <polygon points="10.5 65.5 61.5 65.5 61.5 28.5 10.5 28.5" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M27.795,28.439 L27.795,66.047" />
    <path d="M27.5,28.439 L27.5,65.047" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M44.03,28.439 L44.03,66.047" />
    <path d="M44.5,28.439 L44.5,65.047" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M61.266,40.791 L10.559,40.791" />
    <path d="M61.266,40.791 L10.559,40.791" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M61.266,53.419 L10.559,53.419" />
    <path d="M61.266,53.419 L10.559,53.419" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#8EB0FF"
      d="M87.858,71.882 C87.858,62.199 80.008,54.349 70.325,54.349 C60.641,54.349 52.791,62.199 52.791,71.882 C52.791,81.565 60.641,89.415 70.325,89.415 C80.008,89.415 87.858,81.565 87.858,71.882"
    />
    <path
      stroke="#3A427C"
      d="M87.858,71.882 C87.858,62.199 80.008,54.349 70.325,54.349 C60.641,54.349 52.791,62.199 52.791,71.882 C52.791,81.565 60.641,89.415 70.325,89.415 C80.008,89.415 87.858,81.565 87.858,71.882 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M87.858,71.882 C87.858,62.199 80.008,54.349 70.325,54.349 C60.641,54.349 52.791,62.199 52.791,71.882 C52.791,81.565 60.641,89.415 70.325,89.415 C80.008,89.415 87.858,81.565 87.858,71.882"
    />
    <path d="M84.723,57.484 L82.781,59.426" />
    <path d="M87.858,71.882 C87.858,62.199 80.008,54.349 70.325,54.349 C60.641,54.349 52.791,62.199 52.791,71.882 C52.791,81.565 60.641,89.415 70.325,89.415 C80.008,89.415 87.858,81.565 87.858,71.882 Z" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M70.5,46.328 C68.291,46.328 66.5,48.225 66.5,50.565 L66.5,54.348 L74.5,54.348 L74.5,50.565 C74.5,48.225 72.709,46.328 70.5,46.328"
    />
    <path d="M70.5,46.5 C68.291,46.5 66.5,48.392 66.5,50.726 L66.5,54.5 L74.5,54.5 L74.5,50.726 C74.5,48.392 72.709,46.5 70.5,46.5 Z" />
    <path stroke="#FFFFFF" d="M70.5,71.882 L70.5,83.563" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M74,71.5 C74,69.566 72.433,68 70.501,68 C68.567,68 67,69.566 67,71.5 C67,73.434 68.567,75 70.501,75 C72.433,75 74,73.434 74,71.5"
    />
    <path d="M40.621,69.5 L52.792,69.5" />
    <path d="M53.946,77.5 L33.968,77.5" />
    <path d="M55.619,81.5 L44.51,81.5" />
  </svg>
);

export default PickATime;



// WEBPACK FOOTER //
// ./src/assets/images/icons/pick-a-time.js